import domReady from '@wordpress/dom-ready';

domReady(() => {
  const spokespersons = document.querySelector('.spokespersons');
  const controllers = spokespersons.querySelectorAll('[aria-controls]');

  const firstContent = document.querySelector('.spokespersonContent');
  firstContent.classList.add('showContent');

  const firstButton = document.querySelector('.spokespersonToggle');
  firstButton.classList.add('selectedButton');

  controllers.forEach((controller) => {
    controller.addEventListener('click', () => {
      // ------ Get the id
      const controlledId = controller.getAttribute('aria-controls');

      // ------ Get the content controlled by the id
      const controlledContent = document.getElementById(controlledId);

      // ------ Remove the existing selectedButton classes
      const currentSelectedButtons =
        document.querySelectorAll('.selectedButton');

      currentSelectedButtons.forEach((currentSelectedButton) => {
        currentSelectedButton.classList.remove('selectedButton');
      });

      // ------ Add class to the selected controller to style it
      controller.classList.add('selectedButton');

      // ------ Remove the existing showContent classes
      const currentShownContents = document.querySelectorAll('.showContent');

      currentShownContents.forEach((currentShownContent) => {
        currentShownContent.classList.remove('showContent');
      });

      // ------ Add the showContent class to the desired content
      controlledContent.classList.add('showContent');
    });
  });
});
